interface PartyTabItem {
  id: string;
  label: string;
  joinedCount?: number;
  totalCapacity?: number;
  remainingCount?: number;
  isFull?: boolean;
}

interface PartyTabsProps {
  parties: PartyTabItem[];
  activePartyId: string;
  onChange: (partyId: string) => void;
}

export function PartyTabs({ parties, activePartyId, onChange }: PartyTabsProps): JSX.Element {
  return (
    <div className="party-tabs" role="tablist" aria-label="Event parties">
      {parties.map((party) => {
        const isActive = party.id === activePartyId;

        return (
          <button
            key={party.id}
            type="button"
            className={isActive ? 'party-tabs__button party-tabs__button--active' : 'party-tabs__button'}
            onClick={() => onChange(party.id)}
          >
            <strong>{party.label}</strong>
            {typeof party.totalCapacity === 'number' ? (
              <span>
                {party.joinedCount ?? 0} / {party.totalCapacity}
              </span>
            ) : null}
            {party.isFull ? <span className="party-tabs__state">Full</span> : null}
            {!party.isFull && typeof party.remainingCount === 'number' ? (
              <span className="party-tabs__state">{party.remainingCount} left</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
